// extracted by mini-css-extract-plugin
export var businessTile = "business-partners-list-module--business-tile--b4fdc";
export var partnersWrapper = "business-partners-list-module--partners-wrapper--bf0a5";